// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2w5pW","location":"Header_location__1lzO8"};